import React, { useState, useEffect } from 'react';

import { Col, Row, Divider, Form, Input, Button, Tooltip } from 'antd';
import { MinusCircleOutlined, PlusOutlined, EyeOutlined, EyeInvisibleOutlined, DeleteOutlined } from '@ant-design/icons';

// import fontawesome solid free icons and import trash and eye icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

import ColorPreview from './ColorPreview';

import getColors from 'get-image-colors'

import { t } from '../../../i18n';
import '../index.css';
import { faXmarkCircle } from '@fortawesome/pro-solid-svg-icons';

const ColorPaletteMobile = (props) => {
    return (
        <Form name="dynamic_form_item"
            onValuesChange={(event) => {
                props.setColors(event.colors);

            }} >
            <div 
            // make the padding 0
            style={{ padding: "0px", margin: "0px", marginBottom: "-30px"}}
            >
                <center>
                    <Form.List
                        // initialValue = {props.colors[0][0]}
                        name="colors"
                        rules={[
                            {
                                validator: async (_, names) => {
                                    console.log("The names are", names);
                                    if (!names || names.length < 1) {
                                        return Promise.reject(new Error(t('Select a color')));
                                    }
                                },
                            },
                        ]}
                    >

                        {(fields, { add, remove }, { errors }) => (
                            <div style={{ width: "100%", overflowX: "scroll", overflowY: "hidden", whiteSpace: "nowrap", }} >


{/* {props.colors.map((color, index) => {
        return (
          <Col style={{ maxWidth: '50px', paddingTop: '0px' }}>
            <img
              src={closeCircle}
              style={{ width: "20px", display: "inline", marginBottom: "-30px", }}
              alt="remove-circle"
              onClick={() => {
                var newColors = Object.assign([], props.colors);
                newColors.splice(index, 1);
                props.setColors(newColors);
              }}
            />
            <div
              key={index}
              style={{
                padding: "10px",
                marginRight: "5px",
                borderStyle: "solid",
                borderColor: "#f0f0f0",
                backgroundColor: "#" + color[0],
                width: "40px",
                height: "40px",
                marginLeft: "5px",
              }}
            >
            </div>
          </Col>
        );
      })} */}

<Row style={{ width:`${55*fields.length}px`, overflowX: "scroll", overflowY: "hidden", whiteSpace: "nowrap", }}>
                                {fields.map((field, index) => (
                                    <Form.Item
                                        required={false}
                                        key={field.key}
                                    >
                                        <Col justify="center"
                                        // center the content vertically
                                        align="middle"
                                        // make the width 100px
                                        style={{ maxWidth: '500px', paddingTop: '0px' }}
                                      

                                        >
                                            <Tooltip title={t("Show/Hide Layer")}>
                                                {fields.length > 1 && props.colors[index][1] == false ? (
                                                    <FontAwesomeIcon icon={faEyeSlash} size="lg" 
                                                    // make the color blue
                                                    color="#1890ff"
                                                    style={{
                                                      paddingRight:"10px",

                                                        position: "absolute",
                                                        top: "-5px",
                                                        right: "20px",
                                           
                                                
                                                
                                                }}onClick={
                                                        () => {
                                                            var newColors = Object.assign([], props.colors);
                                                            newColors[index][1] = !newColors[index][1];
                                                            props.setColors(newColors)
                                                            console.log("fields, ", fields);
                                                        }
                                                    } />

                                                ) : null}
                                                {fields.length > 1 && props.colors[index][1] == true ? (

                                                    <FontAwesomeIcon        size="lg" icon={faEye}  
                                                    color="#1890ff"
                                                    style={{paddingRight:"10px",

                                                             position: "absolute",
                                                             top: "-5px",
                                                             right: "20px",
                                                }
                                                
                                                
                                                }
                                                        onClick={() => {
                                                            var newColors = Object.assign([], props.colors);
                                                            newColors[index][1] = !newColors[index][1];
                                                            props.setColors(newColors)
                                                        }}
                                                    />

                                                ) : null}
                                            </Tooltip>
                                            {fields.length > 0 ? (
                                                <div style={{ paddingTop: "10px", borderStyle: "solid", borderColor: "#f0f0f0", backgroundColor: "#" + props.colors[index][0], width: "35px", height: "35px", margin:"10px" }}></div>
                                            ) : null}
                                            {/* <Form.Item
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        whitespace: true,
                                                        message: "Please input color or delete this field.",
                                                    },
                                                ]}
                                                noStyle
                                            >
                                                <Input placeholder="Color" style={{ width: 'calc(90% - 70px)' }} value={props.colors[index][0]} />

                                            </Form.Item> */}


                                            {fields.length > 1 ? (
                                                <FontAwesomeIcon icon={faXmarkCircle} 
                                                // MAKE THE SIZE BIG
                                                size="lg"
                                                // make it red
                                                color="#ff4d4f"
                                                style={{paddingLeft:"10px",
                                            
                                            // make this icon in the corner of the preview box
                                            position: "absolute",
                                            top: "-5px",
                                            right: "0px",
                           



                                            }}
                                                    onClick={() => remove(field.name)}
                                                />

                                            ) : null}
                                        </Col>

                                    </Form.Item>
                                ))}
                      
                                </Row>
                                <Form.Item hidden>
                                    <Row >

                                        <Button
                                            id='addColor'
                                            type="dashed"
                                            onClick={() => {
                                                console.log("clicked color", props.clickedColor);
                                                add([document.getElementById("status").innerHTML.slice(1), true], 0);
                                            }}
                                            style={{ width: '90%' }}
                                            icon={<PlusOutlined />}
                                        >
                                            {/* <div id="color" style={{ margin:"10px", width: "25px", height: "25px" }} ><div id="status" style={{paddingLeft:"30px"}}></div></div> */}

                                            {t("Click Image")}
                                        </Button>
                                    </Row>
                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </div>
                        )}
                    </Form.List>
                </center>
            </div>
            {/* <Divider style={{ margin: '0px' }} /> */}
        </Form>
    );
};

export default ColorPaletteMobile;
